import { z } from "zod";
import { NegotiationAvailableProductData } from "../types/applicableProduct.type";
import { unFormatCurrency, unFormatUnknownUnit } from "@/common/utils/unFormatters";

export const negotiationSchema = z.object({
  observation: z.string({ message: 'Campo obrigatório' }).min(1, { message: 'Campo obrigatório' }),
  negotiation_products_attributes: z.array(
    z.object({
      product_id: z.string({ message: 'Campo obrigatório' }),
      product: z.custom<NegotiationAvailableProductData>(),
      value: z.string({ message: 'Campo obrigatório' }).refine((value) => value && unFormatCurrency(value), { message: 'Campo obrigatório' }),
      quantity: z.string({ message: 'Campo obrigatório' }).refine((value) => value && unFormatUnknownUnit(value), { message: 'Campo obrigatório' }),
    }),
  ),
});

export type NegotiationValidationSchema = z.infer<typeof negotiationSchema>;
